/**
 * Created by wuhuping on 2017/6/6.
 */
export default {
  add0(m) {
    return m < 10 ? '0' + m : m
  },
  dateformate_yyyyMMddHH(date) {
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    return year + this.add0(month) + this.add0(day) + this.add0(hour)
  },
  dateformate_yyyyMMdd(date) {
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    return year + '-' + this.add0(month) + '-' + this.add0(day)
  },
  sensorsDateFormate() {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let minute = date.getMinutes()
    let seconds = date.getSeconds()
    return year + '-' + this.add0(month) + '-' + this.add0(day) + ' - ' + this.add0(hour) + ':' + this.add0(minute) + ':' + this.add0(seconds)
  },
  plusOneDayWithFormate_yyyyMMdd(dateFormateStr) {
    if (dateFormateStr.length === 10) {
      let year = dateFormateStr.substr(0, 4)
      let month = dateFormateStr.substr(5, 2)
      let day = dateFormateStr.substr(8, 2)
      let date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
      date.setDate(date.getDate() + 1)
      return date.getFullYear() + '-' + this.add0(date.getMonth() + 1) + '-' + this.add0(date.getDate())
    } else {
      return dateFormateStr
    }
  },
  reduceOneDayWithFormate_yyyyMMdd(dateFormateStr) {
    if (dateFormateStr.length === 10) {
      let year = dateFormateStr.substr(0, 4)
      let month = dateFormateStr.substr(5, 2)
      let day = dateFormateStr.substr(8, 2)
      let date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
      date.setDate(date.getDate() - 1)
      return date.getFullYear() + '-' + this.add0(date.getMonth() + 1) + '-' + this.add0(date.getDate())
    } else {
      return dateFormateStr
    }
  },
  yyyyMMddFormate2Date(dateFormateStr) {
    if (dateFormateStr.length === 10) {
      let year = dateFormateStr.substr(0, 4)
      let month = dateFormateStr.substr(5, 2)
      let day = dateFormateStr.substr(8, 2)
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
    } else {
      return new Date();
    }
  },
  zerofill(m) {
    return m < 10 ? '0' + m : m
  },
  setTime() {
    let date = new Date()
    let seperator1 = ''
    let seperator2 = ''
    let month = date.getMonth() + 1
    let strDate = date.getDate()
    let hours = date.getHours()
    let minutes = date.getMinutes()
    let seconds = date.getSeconds()
    let milliseconds = date.getMilliseconds()
    let currentdate = date.getFullYear() + seperator1 + this.zerofill(month) + seperator1 + this.zerofill(strDate) + this.zerofill(hours) + this.zerofill(minutes) + seperator2 + this.zerofill(seconds) + seperator2 + this.zerofill(milliseconds)
    return currentdate
  }
}



// WEBPACK FOOTER //
// ./src/tools/dateFormatter.js